import { useParams } from 'react-router-dom'

export interface HomeRouteParams {
  homeId: string
}

export function useHomeRouteParams() {
  return useParams<HomeRouteParams>()
}
